export default "__VITE_ASSET__Dj5XkQha__"